<script setup lang="ts">
import AggregatorsPage from '../features/aggregators/AggregatorsPage.vue';
</script>

<template>
  <AggregatorsPage />
</template>
